import MainPageHeaderMobile from "common/components/MainPageHeader/MainPageHeaderMobile";
import ProfileTabs from "features/profile/components/ProfileTabs";
import React from "react";

interface Props {
  dataOrders?: any[];
}

const MyProfileMobile = ({ dataOrders }: Props) => {
  return (
    <div className="main-profile-mobile-wrapper">
      <MainPageHeaderMobile title="החשבון שלי" />
      <ProfileTabs dataOrders={dataOrders} />
    </div>
  );
};

export default MyProfileMobile;
